// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610191735/js/" + chunkId + "." + {"44":"d9d14c9c","225":"bb3db48f","481":"3d014848","486":"d92961e5","770":"5206fb42"}[chunkId] + ".0.8415272232146742.chunk.js";
};